// Pop-out support is intentionally opt-in. Widgets not listed here may use
// maps, video, modals, fullscreen APIs, commands, or global document/window
// state that is not safe when their DOM is hosted by a second document.
const POPOUT_SUPPORTED_WIDGET_IDS = new Set([
  1, // Severe Weather Warnings map
  2, // Hourly Forecast
  3, // Current Conditions map
  4, // Detailed Forecast
  5, // 15 Day Forecast
  6, // Air Quality Observations
  7, // Air Quality Forecast
  8, // NWS Alerts
  9, // My Forecast Advisories
  10, // Wave and Wind Conditions
  11, // Surf Alerts
  12, // Buoy Conditions
  13, // Tide Table
  14, // Earthquake map
  15, // Hurricanes & Tropical Storms map
  16, // Detailed Forecast Chart
  17, // 7 Day Forecast Chart
  18, // 15 Day Forecast Chart
  19, // Chance of Precipitation Chart
  20, // Comfort Level Chart
  21, // Dew Point Chart
  22, // Humidity Chart
  23, // Pressure Chart
  24, // Precipitation Chart
  25, // Temperature Chart
  26, // Wind Speed Chart
  27, // Fire Danger
  28, // Airport Delays
  29, // Ski Reports
  31, // Flood Stage map
  32, // Doppler map
  39, // USGS Monitoring Station map
  103, // Overwatch VMS
  104, // Buoy map
]);

export const canWidgetUsePopout = (widget) => {
  const widgetId = Number(widget?.id);
  return Number.isInteger(widgetId) && POPOUT_SUPPORTED_WIDGET_IDS.has(widgetId);
};
